// Lookup tables for each coordinate's contribution to the Morton code
// Usage: MORTON_X_BITS[x] | MORTON_Y_BITS[y] | MORTON_Z_BITS[z]

// X bits (000): Bits go into positions 0,3,6,9
export const MORTON_X_BITS = [
  0b000000000000, // 0
  0b000000000001, // 1
  0b000000001000, // 2
  0b000000001001, // 3
  0b000001000000, // 4
  0b000001000001, // 5
  0b000001001000, // 6
  0b000001001001, // 7
  0b001000000000, // 8
  0b001000000001, // 9
  0b001000001000, // 10
  0b001000001001, // 11
  0b001001000000, // 12
  0b001001000001, // 13
  0b001001001000, // 14
  0b001001001001, // 15
] as const;

// Y bits (001): Bits go into positions 1,4,7,10
export const MORTON_Y_BITS = [
  0b000000000000, // 0
  0b000000000010, // 1
  0b000000010000, // 2
  0b000000010010, // 3
  0b000010000000, // 4
  0b000010000010, // 5
  0b000010010000, // 6
  0b000010010010, // 7
  0b010000000000, // 8
  0b010000000010, // 9
  0b010000010000, // 10
  0b010000010010, // 11
  0b010010000000, // 12
  0b010010000010, // 13
  0b010010010000, // 14
  0b010010010010, // 15
] as const;

// Z bits (010): Bits go into positions 2,5,8,11
export const MORTON_Z_BITS = [
  0b000000000000, // 0
  0b000000000100, // 1
  0b000000100000, // 2
  0b000000100100, // 3
  0b000100000000, // 4
  0b000100000100, // 5
  0b000100100000, // 6
  0b000100100100, // 7
  0b100000000000, // 8
  0b100000000100, // 9
  0b100000100000, // 10
  0b100000100100, // 11
  0b100100000000, // 12
  0b100100000100, // 13
  0b100100100000, // 14
  0b100100100100, // 15
] as const;

const createReverseMap = (table: readonly number[]) => {
  const map = new Map<number, number>();
  table.forEach((value, index) => {
    map.set(value, index);
  });
  return map;
};

// Generate reverse maps
export const REVERSE_MORTON_X_BITS = createReverseMap(MORTON_X_BITS);
export const REVERSE_MORTON_Y_BITS = createReverseMap(MORTON_Y_BITS);
export const REVERSE_MORTON_Z_BITS = createReverseMap(MORTON_Z_BITS);

export function deinterleaveMortonCode(mortonCode: number): [number, number, number] {
  const xMask = 0b001001001001; // Mask for positions 0, 3, 6, 9
  const yMask = 0b010010010010; // Mask for positions 1, 4, 7, 10
  const zMask = 0b100100100100; // Mask for positions 2, 5, 8, 11

  const xBits = mortonCode & xMask;
  const yBits = mortonCode & yMask;
  const zBits = mortonCode & zMask;

  const x = REVERSE_MORTON_X_BITS.get(xBits) ?? 0; // Default to 0 if not found
  const y = REVERSE_MORTON_Y_BITS.get(yBits) ?? 0;
  const z = REVERSE_MORTON_Z_BITS.get(zBits) ?? 0;

  return [x, y, z];
}
